// @mui
import {
  Typography,
  Stack,
  Box,
  Divider,
  Chip,
  Fade,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import { alpha } from "@mui/material/styles";
// hooks
import useAuth from '../../../hooks/useAuth';
// components
import Iconify from '../../../components/Iconify';
import DIOText from '../../../components/DIOText';
import SvgIconStyle from "../../../components/SvgIconStyle";
import {
  RequestUpdateProfileDialogButton,
  FliersDetailStepper,
} from '../';
import { FreeCoffeeChatDialogButton } from '../../../sections/scout';
// utils
import { fKrKSTFile } from '../../../utils/formatTime';


export default function CrewInfoTabPanel({ profile, coffeeChat }) {
  const { user } = useAuth();
  const paidPlan = user?.employee?.company?.[0]?.scout_plan === 'enterprise' || user?.employee?.company?.[0]?.scout_plan === 'pro';
  const showCoffeChatInfo = (!profile?.coffee_chat_ing && coffeeChat?.coffee_chat_status !== "evaluable");
  const scoutDeclined = coffeeChat?.company_decline_reason !== "" && coffeeChat?.company_decline_reason !== null && coffeeChat?.company_decline_reason !== undefined;

  return (
    <Fade in={profile && !!profile.id}>
    <Box
      id="coffee-chat-tabpanel-info"
      aria-labelledby="coffee-chat-tab-info"
    >

      {/* 추천사유 */}
      {profile?.scout_reason && (
      <Stack
        sx={{
          backgroundColor: "grey.100",
          borderRadius: 2,
          p: 2.5,
          border: "1px solid #919EAB3D",
        }}
        spacing={1.5}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <SvgIconStyle src={`/icons/icon-loudspeaker-mono.svg`} sx={{ color: "info.main", minWidth: 20, minHeight: 20, maxWidth: 20, maxHeight: 20 }} />
          <Typography variant="h6">
            <DIOText />에서 이 크루를 추천한 이유
          </Typography>
        </Stack>
        <Stack spacing={1} sx={{ width: 1, overflow: "hidden" }}>
        {profile?.scout_reason?.split('\n').filter(m => m).map((line, index) => (
          <Stack key={index} direction="row" spacing={1} alignItems="flex-start">
            <SvgIconStyle src={"/icons/icon-check-mono.svg"} sx={{ minWidth: 16, minHeight: 16, maxWidth: 16, maxHeight: 16, my: 0.5 }} />
            <Typography variant="body2">
              {line}
            </Typography>
          </Stack>
        ))}
        </Stack>
      </Stack>
      )}

      {showCoffeChatInfo && !scoutDeclined && (
      <>
      <Divider sx={{ mt: 3 }} />
      <Accordion sx={{ p: 1, '&.MuiAccordion-root' : { my: 0, '&:before': { opacity: 0 } } }}>
        <AccordionSummary
          expandIcon={<Iconify icon={'eva:arrow-ios-downward-fill'} width={20} height={20} />}
        >
          <Stack direction="row" alignItems={"center"} spacing={1}>
            <SvgIconStyle src={"/icons/icon-coffee-mono.svg"} sx={{ width: 20, height: 20, color: "text.disabled" }} />
            <Typography variant="subtitle1" paragraph>
              커피챗은 이렇게 진행돼요.
            </Typography>
          </Stack>
        </AccordionSummary>
        <AccordionDetails sx={{ mb: 1, px: 0 }}>
          <FliersDetailStepper />
        </AccordionDetails>
      </Accordion>
      <Divider />
      </>
      )}

      <Stack direction="row" sx={{ mt: 3 }} alignItems={"center"} spacing={1}>
        <Iconify icon={'eva:clock-outline'} sx={{ width: 16, height: 16, color: "text.secondary" }} />
        <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
          최근 프로필 수정 일시
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {fKrKSTFile(profile?.last_updated_at)}
        </Typography>
      </Stack>



      {profile?.interest_in_changing_job && (
      <Stack spacing={1} sx={{ mt: 3 }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Iconify icon={'eva:star-fill'} sx={{ width: 24, height: 24, color: "secondary.main" }} />
          <Typography variant="h6">
            크루의 이직 의사
          </Typography>
        </Stack>
        {/* prepare */}
        {profile?.interest_in_changing_job === "prepare" && (
          <Stack sx={{ pl: 3, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }} spacing={1}>
            <Typography variant="body1" sx={{ pl: 1 }}>
              현재 이직 준비 중이에요.
            </Typography>
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              sx={{
                p: 1,
                borderRadius: 1,
                backgroundColor: (theme) => alpha(theme.palette.info.main, 0.08),
                border: "none",
                boxShadow: "none",
              }}
            >
              <Iconify icon="eva:info-fill" sx={{ color: "info.light", minWidth: 16, minHeight: 16 }} />
              <Typography variant="caption">
                만나보시고 마음에 들면, 이직을 제안해보세요.
              </Typography>
            </Stack>
          </Stack>
        )}
        {/* soon */}
        {profile?.interest_in_changing_job === "soon" && (
          <Stack sx={{ pl: 3, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }} spacing={1}>
            <Typography variant="body1" sx={{ pl: 1 }}>
              당장은 생각이 없지만 곧 준비하려고 해요.
            </Typography>
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              sx={{
                p: 1,
                borderRadius: 1,
                backgroundColor: (theme) => alpha(theme.palette.info.main, 0.08),
                border: "none",
                boxShadow: "none",
              }}
            >
              <Iconify icon="eva:info-fill" sx={{ color: "info.light", minWidth: 16, minHeight: 16 }} />
              <Typography variant="caption">
                만나보시고 마음에 들면, 이직을 제안해보세요.
              </Typography>
            </Stack>
          </Stack>
        )}
        {/* no */}
        {profile?.interest_in_changing_job === "no" && (
          <Stack sx={{ pl: 4, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }} spacing={2}>
            <Typography variant="body1">
              지금 이직 생각은 없지만, <br />
              회사에 관심이 있어서 만나보고 싶어요.
            </Typography>
          </Stack>
        )}
      </Stack>
      )}

      {profile?.intro && (
      <Stack spacing={1} sx={{ mt: 3 }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <SvgIconStyle src={`/icons/ic_person.svg`} sx={{ color: "secondary.main" }} />
          <Typography variant="h6">
            크루 소개
          </Typography>
        </Stack>
        <Stack sx={{ pl: 4, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }} spacing={2}>
          <Typography variant="body1">
            {profile?.intro}
          </Typography>
        </Stack>
      </Stack>
      )}

      <Stack spacing={1} sx={{ mt: 3 }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <SvgIconStyle src={`/icons/icon-shield-user-mono.svg`} sx={{ color: "secondary.main" }} />
          <Typography variant="h6">
            세부 포지션
          </Typography>
        </Stack>
        <Stack sx={{ pl: 4, whiteSpace: 'pre-wrap' }} spacing={1}>
          {profile?.main_role && (
            <Stack direction="row" spacing={1} alignItems="baseline" sx={{ flexWrap: 'wrap', gap: 1, }}>
              <Typography variant="subtitle1" sx={{ color: "text.secondary" }} whiteSpace="nowrap">메인</Typography>
              <Chip
                label={profile?.main_role}
                sx={{ backgroundColor: (theme) => alpha(theme.palette.secondary.main, 0.16), color: "text.primary" }}
              />
            </Stack>
          )}
          {profile?.sub_roles?.length > 0 && (
            <Stack direction="row" spacing={1} alignItems="baseline" sx={{ flexWrap: 'wrap', gap: 1, }}>
              <Typography variant="subtitle1" sx={{ color: "text.secondary" }} whiteSpace="nowrap">서브</Typography>
              {profile?.sub_roles?.map((r, index) => (
                <Chip key={index} label={r} sx={{ backgroundColor: "grey.200", color: "text.secondary" }} />
              ))}
            </Stack>
          )}
        </Stack>
      </Stack>

      {profile?.categories?.length > 0 && (
      <Stack spacing={1} sx={{ mt: 3 }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <SvgIconStyle src={`/icons/ic_trophy.svg`} sx={{ color: "secondary.main" }} />
          <Typography variant="h6">
            경력 카테고리
          </Typography>
        </Stack>
        <Stack sx={{ pl: 4, whiteSpace: 'pre-wrap' }}>
          <Stack direction="row" spacing={0.5} alignItems="baseline">
            {profile?.categories?.map((c, index) => (
              <Chip key={index} label={c} />
            ))}
          </Stack>
        </Stack>
      </Stack>
      )}

      <Stack spacing={1} sx={{ mt: 3 }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <SvgIconStyle src={`/icons/ic-job.svg`} sx={{ color: "secondary.main" }} />
          <Typography variant="h6">
            크루 경력 정보
          </Typography>
        </Stack>
        <Stack sx={{ pl: 4, whiteSpace: 'pre-wrap' }} spacing={2} divider={<Divider />}>
          {profile?.careers?.map((c, index) => (
            <Stack key={index} spacing={1} alignItems="baseline">
              <Typography variant="subtitle1" sx={{ wordBreak: "break-all" }}>{c?.name}</Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }} whiteSpace="nowrap">{c?.period}</Typography>
              {c?.description && (<Typography variant="body1" sx={{ wordBreak: "break-all", whiteSpace: 'pre-wrap' }}>{c?.description}</Typography>)}
            </Stack>
          ))}
        </Stack>
      </Stack>

      {profile?.employment_type && (
      <Stack spacing={1} sx={{ mt: 3 }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Iconify icon={'eva:sun-outline'} sx={{ width: 24, height: 24, color: "secondary.main" }} />
          <Typography variant="h6">
            현재 본업 고용 형태
          </Typography>
        </Stack>
        <Stack sx={{ pl: 4, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }} spacing={2}>
          <Typography variant="body1">
            {profile?.employment_type}
          </Typography>
        </Stack>
      </Stack>
      )}

      {profile?.work_place && (
      <Stack spacing={1} sx={{ mt: 3 }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <SvgIconStyle src={`/icons/icon-building-mono.svg`} sx={{ color: "secondary.main" }} />
          <Typography variant="h6">
            현재 본업 근무 장소
          </Typography>
        </Stack>
        <Stack sx={{ pl: 4, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }} spacing={2}>
          <Typography variant="body1">
            {profile?.work_place}
          </Typography>
        </Stack>
      </Stack>
      )}

      {/* 프로필 요청 */}
      {!profile?.coffee_chat_ing && !scoutDeclined && (
      <Box
        sx={{
          borderRadius: 2,
          border: "1px solid #919EAB3D",
          p: { xs: 2, sm: 3 },
          my: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography variant="subtitle1" sx={{ pb: { xs: 1, sm: 2 }}}>
          정보가 너무 적다면, 크루에게 요청해보세요.
        </Typography>
        {paidPlan && (
          <RequestUpdateProfileDialogButton profile={profile} freeSolo />
        )}
        {!paidPlan && (
          <FreeCoffeeChatDialogButton sx={{ mt: 0, width: "none" }} buttonTitle="프로필 작성 요청하기" buttonSource="request-profile" />
        )}
      </Box>
      )}
    </Box>
    </Fade>
  )
};
